import React from "react";

import { ValuationBadge } from "../../../components/Valuation";
import { pointDetailsOf } from "./pointDetails";
import { Details, DetailLine, WarningLine } from "./styles";
import { HistoryPointDetailsProps } from "./types";

export const HistoryPointDetails: React.FC<HistoryPointDetailsProps> = ({
  point,
}) => {
  const { source, warnings, blockedMessage } = pointDetailsOf(point);

  if (!source && warnings.length === 0 && !blockedMessage) {
    return null;
  }

  return (
    <Details>
      {source && <DetailLine>Source: {source}</DetailLine>}
      {warnings.map(({ key, badge }) => (
        <WarningLine key={key}>
          <ValuationBadge badge={badge} hasVisibleNote />
          <span>{badge.message}</span>
        </WarningLine>
      ))}
      {blockedMessage && <DetailLine>{blockedMessage}</DetailLine>}
    </Details>
  );
};
